<template>
  <div>
    <base-screen>
      <el-form
        size="small"
        :inline="true"
        :model="screenData"
        ref="screenForm"
        @keydown.native.enter="screenSubmit">
        <el-form-item label="订单编号：" prop="orderNo">
          <el-input type="text"
                    v-model="screenData.orderNo"
                    placeholder="请输入订单编号"
                    autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="客户名称：" prop="name">
          <el-input type="text" v-model="screenData.name" placeholder="请输入客户名称"
                    autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="负责人：" prop="fzName">
          <el-input type="text" v-model="screenData.fzName" placeholder="请输入负责人"
                    autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="结算状态：" prop="settleState">
          <el-select v-model="screenData.settleState" placeholder="请选择结算状态">
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间：">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户评价：" prop="evaluate">
          <el-select v-model="screenData.evaluate" placeholder="请选择服务评价">
            <el-option label="非常满意" value="1"></el-option>
            <el-option label="很满意" value="2"></el-option>
            <el-option label="还不错" value="3"></el-option>
            <el-option label="一般" value="4"></el-option>
            <el-option label="差" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-screen" type="primary" @click="screenSubmit">查询</el-button>
          <el-button type="text" @click="resetScreen">重置</el-button>
          <el-button
            class="btn-screen excel-left"
            type="primary"
            @click="exportExcel"
            icon="el-icon-download"
            :loading="exportLoading">
            导出excel
          </el-button>
        </el-form-item>
      </el-form>
    </base-screen>
    <div class="page-box">
      <el-table
        :data="tableData"
        v-loading="loading">
        <el-table-column
          prop="orderNo"
          label="订单编号"
          width="165">
          <div class="link"
               slot-scope="{row}"
               @click="$router.push({path: `/member/orderDetail/${row.orderNo}`})">
            {{ row.orderNo }}
          </div>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="下单时间">
        </el-table-column>
        <el-table-column
          prop="name"
          label="客户名称"
          width="90">

        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式">
        </el-table-column>
        <!--<el-table-column-->
        <!--prop="serviceName"-->
        <!--label="预约服务">-->
        <!--</el-table-column>-->
        <el-table-column
          prop="orderTime"
          label="开始时间">
        </el-table-column>
        <el-table-column
          prop="endTime"
          label="完成时间">
        </el-table-column>
        <el-table-column
          prop="evaluate"
          label="评价"
          width="94">
             <span slot-scope="{row}">
              <template v-if="row.evaluate==='1'">#非常满意#</template>
              <template v-if="row.evaluate==='2'">#很满意#</template>
              <template v-if="row.evaluate==='3'">#还不错#</template>
              <template v-if="row.evaluate==='4'">#一般#</template>
              <template v-if="row.evaluate==='5'">#差#</template>
              </span>
        </el-table-column>
        <el-table-column
          prop="orderAmount"
          label="费用">
        </el-table-column>
        <el-table-column
          prop="leaderName"
          label="负责人">
        </el-table-column>
        <el-table-column
          prop="employeeName"
          label="服务人员">
        </el-table-column>
        <el-table-column
          prop="settleState"
          label="结算状态">
          <div slot-scope="{row}">
            <icon-svg v-if="row.settleState ==='0'" icon-class="status-warning"></icon-svg>
            <icon-svg v-if="row.settleState ==='1'" icon-class="status-done"></icon-svg>
            <span v-if="row.settleState ==='1'" class="state-rem">
                已结算
              </span>
            <span v-if="row.settleState ==='0'" class="state-rem">
                未结算
              </span>
          </div>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="{row}">
            <template v-if="row.orderState === '7' && row.settleState === '0'">
              <el-button class="link" type="text" v-pms="'settleFinishOrderForm'"
                         @click="settleFinishOrderForm(row.orderNo,row.orderFormId)">结算
              </el-button>
            </template>
            <template v-else>
              <el-button class="link" type="text" v-pms="'settleFinishOrderFormDetail'" @click="settleFinishOrderFormDetail(row.orderNo,row.orderFormId)">结算详情
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>

      <el-dialog
        title="订单结算"
        :modal="false"
        :visible.sync="dialogTableVisible">
        <div>
          <div style=" height:40px; text-align: center;">
            <div class="left" style="height:20px;">订单金额：{{orderAmount}}</div>
            <div class="left" style="height:20px;">退款：{{refundAmount}}</div>
            <div class="left" style="height:20px;">实收金额：{{receivedAmount}}</div>
          </div>
        </div>

        <el-table
          :data="gridData"
          ref="subData"
          tooltip-effect="dark"
          max-height="400"
          stripe
        >
          <el-table-column
            label="结算人员"
          >
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column
            label="结算金额"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.total">{{totalAmount}}</div>
              <el-input v-else
                        placeholder="请输入结算金额"
                        v-model="scope.row.amount"
                        @change="handlePriceChange()"
                        clearable>
              </el-input>
            </template>
          </el-table-column>
        </el-table>

        <span slot="footer" style="text-align: center">
            <el-button @click="dialogTableVisible=false">取 消</el-button>
            <el-button type="primary" @click="submitSettleFinishOrderForm()">保存</el-button>
          </span>
      </el-dialog>

      <el-dialog
        title="结算详情"
        :modal="false"
        :visible.sync="dialogTableVisibleDetail">
        <div>
          <div style=" height:40px; text-align: center;">
            <div class="left" style="height:20px;">订单金额：{{orderAmount}}</div>
            <div class="left" style="height:20px;">退款：{{refundAmount}}</div>
            <div class="left" style="height:20px;">实收金额：{{receivedAmount}}</div>
          </div>
        </div>

        <el-table
          :data="gridDataDetail"
          ref="subData"
          tooltip-effect="dark"
          max-height="400"
          stripe
        >
          <el-table-column
            label="结算人员"
          >
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column
            label="结算金额"
            align="center"
          >
            <template slot-scope="scope">
              <div>{{scope.row.amount}}</div>
            </template>
          </el-table-column>
        </el-table>

        <span slot="footer" style="text-align: center">
            <el-button @click="dialogTableVisibleDetail=false">关 闭</el-button>
          </span>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import {order, employee} from '@/api'
import {orderStatus, dateRangeShortcut} from '@/utils/constant'
import dayjs from 'dayjs'
import {minus, plus} from 'number-precision'

export default {
  name: 'OrderSettle',
  props: {
    param: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      orderFormId: '',
      orderNo: '',
      totalAmount: 0,
      orgCode: this.$store.state.user.orgCode,
      screenData: {
        orderNo: '',
        orderState: '7',
        orgCode: this.$store.state.user.orgCode,
        name: '',
        fzName: '',
        offBeginCreateDate: '',
        offEndCreateDate: '',
        settleState: ''
      },
      page: {
        pageSize: 10,
        pageNum: 1
      },
      dateRange: '', //
      tableData: [],
      pickerOptions: {
        shortcuts: dateRangeShortcut
      },
      exportLoading: false,
      gridData: [],
      gridDataDetail: [],
      orderAmount: '',
      refundAmount: '',
      receivedAmount: '',
      dialogTableVisible: false,
      dialogTableVisibleDetail: false
    }
  },
  watch: {
    dateRange (val) {
      this.setScreeData(val)
    }
  },
  created () {
    this.getData()
  },
  methods: {
    setScreeData (val) {
      this.screenData.offBeginCreateDate = val ? dayjs(val[0]).format('YYYY-MM-DD HH:mm:ss') : ''
      this.screenData.offEndCreateDate = val ? dayjs(val[1]).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    async settleFinishOrderForm (orderNo, orderFormId) {
      let {data} = await order.getOrderDetail(orderNo)
      let obj = await order.getOrderEmployeeList(orderFormId)
      this.orderAmount = data.orderAmount
      this.refundAmount = data.refundAmount
      if (data.refundAmount) {
        this.receivedAmount = minus(data.orderAmount, data.refundAmount)
      } else {
        this.refundAmount = 0
        this.receivedAmount = data.orderAmount
      }
      this.gridData = []
      if (data.leaderId) {
        let leaderObj = {
          orderFormId: orderFormId,
          employeeType: '1',
          employeeId: data.leaderId,
          name: data.leaderName,
          amount: 0,
          createUser: this.$store.state.user.userId
        }
        this.gridData.push(leaderObj)
      }
      if (obj.data.length > 0) {
        obj.data = obj.data.map((data) => ({
          orderFormId: orderFormId,
          employeeType: '2',
          employeeId: data.employeeId,
          name: data.name,
          amount: 0,
          createUser: this.$store.state.user.userId
        }))
        this.gridData = [...this.gridData, ...obj.data]
      }

      this.gridData.push({name: '共计', amount: '', total: true})
      this.orderFormId = orderFormId
      this.orderNo = orderNo
      this.totalAmount = 0
      this.dialogTableVisible = true
    },
    async settleFinishOrderFormDetail (orderNo, orderFormId) {
      let {data} = await order.getOrderDetail(orderNo)
      let obj = await order.getOrderSettleList(orderFormId)
      this.orderAmount = data.orderAmount
      this.refundAmount = data.refundAmount
      if (data.refundAmount) {
        this.receivedAmount = minus(data.orderAmount, data.refundAmount)
      } else {
        this.refundAmount = 0
        this.receivedAmount = data.orderAmount
      }
      this.gridDataDetail = []
      let totalMoney = 0
      if (obj.data.length > 0) {
        obj.data = obj.data.map((data) => ({
          name: data.name, amount: data.amount
        }))
        this.gridDataDetail = [...this.gridDataDetail, ...obj.data]
      }
      this.gridDataDetail.map(x => {
        totalMoney = plus(totalMoney, x.amount)
      })
      this.gridDataDetail.push({name: '共计', amount: totalMoney})
      this.dialogTableVisibleDetail = true
    },
    async submitSettleFinishOrderForm () {
      this.$confirm(`确定给订单号：【${this.orderNo}】结算么?`, '系统提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action, instance) => {
          if (action === 'confirm') {
            await order.updateOrderFromSettle({
              orderFormId: this.orderFormId,
              settleState: '1',
              settleId: this.$store.state.user.userId,
              orderSettleList: this.gridData.splice(0, this.gridData.length - 1)
            })
            this.dialogTableVisible = false
            this.resetScreen()
          } else {
            this.$message({
              type: 'info',
              message: '取消结算'
            })
          }
        }
      })
    },
    handlePriceChange () {
      this.totalAmount = 0
      this.gridData.map(x => {
        this.totalAmount = plus(this.totalAmount, x.amount)
      })
    },
    async exportExcel () {
      this.exportLoading = true
      await order.getOrderSettleExcelList({
        param: this.screenData
      }, '订单结算')
      this.exportLoading = false
    },
    async getData () {
      this.loading = true
      let {data, page} = await order.getOrderListPage({
        param: this.screenData,
        page: this.page
      })
      this.loading = false
      this.page = page
      this.tableData = data
    },
    screenSubmit () {
      this.page.pageNum = 1
      this.getData()
    },
    resetScreen () {
      this.$refs.screenForm.resetFields()
      this.setScreeData(false)
      this.dateRange = ''
      this.page.pageNum = 1
      this.getData()
    },
    handleSizeChange (arg) {
      this.page.pageSize = arg
      this.getData()
    },
    handleCurrentChange (arg) {
      this.page.pageNum = arg
      this.getData()
    },
    tabSelected (tab) {
      this.screenData.policyRenewStatPeriod = this.tabsData[tab.index].id
      this.page.pageNum = 1
      this.getData()
    }
  }
}
</script>

<style>
  .el-dialog__footer {
    text-align: center;
  }
</style>
<style lang="scss" scoped>
  .left {
    float: left;
    width: 33%;
  }

  .state-rem {
    font-size: 13px;
    color: #b4b4b4;
  }

  .excel-left {
    margin-left: 30px !important;
  }

  .my-autocomplete {
    min-width: 232px;
    width: auto !important;
    li {
      line-height: normal;
      padding: 7px;
      .name {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addr {
        font-size: 12px;
        color: #b4b4b4;
      }
      .highlighted .addr {
        color: #ddd;
      }
    }
  }

  .detail-list {
    padding: 24px 0;
    *zoom: 1;
    *clear: both;
    &:before,
    &:after {
      display: table;
      clear: both;
      content: "";
    }
    .list-item {
      float: left;
      width: 33.333333333333%;
      font-size: 14px;
      color: #777;
      line-height: 40px;
      span {
        display: inline-block;
        min-width: 90px;
        text-align: right;
      }
    }
  }
</style>
